<template>
  <div class="account-management container-style">
    <el-card class="searchCard" shadow="never">
      <el-form :inline="true" :model="searchForm" class="form-inline">
        <el-form-item label="创建时间:">
          <datePicker @change="dateChange" :vModel="createTime" v-model="createTime"></datePicker>
        </el-form-item>
          <el-form-item label="加盟商姓名:">
          <el-input v-model="searchForm.userName" placeholder="员工姓名" clearable></el-input>
        </el-form-item>
         <el-form-item label="账号:">
          <el-input v-model="searchForm.userAccount" placeholder="员工账号" clearable></el-input>
        </el-form-item>
        <el-form-item label="联系方式:">
          <el-input v-model="searchForm.phone" placeholder="联系方式" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <!-- <el-button @click.native="searchClick">
            查询
          </el-button>
           <el-button @click.native="goAddPartner">
            新建
          </el-button> -->
           <auth-button opt="search" :plain="true" icon="el-icon-search" @click.native="searchClick" label="查询" :loading="loadingTable"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button opt="add" icon="el-icon-plus" @click.native="goAddPartner" label="新建"></auth-button>
          </el-form-item>
      </el-form>
    </el-card>
     <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="loadingTable"
        :data="tableData"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="userName"
          label="加盟商姓名"
          align="center">
        </el-table-column>
        <el-table-column
          prop="userAccount"
          label="账号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          align="center">
        </el-table-column>
        <el-table-column
          prop="brandList"
          label="品牌"
          align="center">
          <template slot-scope="scope">
             <el-tag
              type="info"
              style="margin:0 2px"
              size="small"
              v-for="(item,index) in scope.row.brandList"
              :key="index">
              {{ item.brandName }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="zoneList"
          label="区域"
          align="center">
          <template slot-scope="scope">
            <span  v-for="(item,index) in scope.row.zoneList"
              :key="index">
                {{ item.zoneName }} <template v-if="index!= scope.row.zoneList.length-1">、</template>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="fStatus"
          label="操作"
          align="center"
          fixed="right"
          width="200"
          :context="_self">
          <template slot-scope="scope">
             <auth-button
              opt="edit"
              type="text"
              @click.native="goAddPartner(scope.row)"
              label="编辑"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination :size="paginations.pageSize" @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import { parseTime } from '@/utils/formatTime'
import datePicker from '@/components/datePicker'
import pagination from '@/components/pagination'
import { getPartnerList } from '@/api/setting.js'
// import qs from 'qs'
export default {
  components: {
    datePicker,
    pagination
  },
  data () {
    const todayStr = (parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')).substr(0, 10) + ' 23:59:59'
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}').substr(0, 10) + ' 00:00:00'
    return {
      createTime: [todayZeroStr, todayStr],
      searchForm: {
        startTime: '',
        endTime: '',
        userName: '',
        userAccount: '',
        phone: ''
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 10
      },
      loadingTable: false,
      tableData: []
    }
  },
  mounted () {
    this.dateChange(this.createTime)
    this.getList()
  },
  methods: {
    dateChange (value) {
      if (value !== null) {
        [this.searchForm.startTime, this.searchForm.endTime] = value
      } else {
        [this.searchForm.startTime, this.searchForm.endTime] = ['', '']
      }
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.getList()
    },
    searchClick () {
      this.paginations.pageNo = 1
      this.getList()
    },
    goAddPartner ({ id }) {
      this.$router.push({ path: '/MerchantSetting/MerchantInfoSetting/add-partner', query: { id: id || '' } })
    },
    getList () {
      this.loadingTable = true
      const params = Object.assign(this.searchForm, this.paginations)
      console.log('params: ', params)
      getPartnerList(params).then(response => {
        this.loadingTable = false
        if (+response.error_code === 0) {
          this.tableData = response.data.list
          this.paginations.count = response.data.count
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
